/**
 * Permission codes the Currency Rates screen (FSD 1.2.7.10, F-6.006, F-6.011)
 * declares an interest in — the dot-strings `server/internal/fx/permissions.go`
 * registers. The foundation routes wrap the same `fx.Service`, so they are
 * guarded by the same codes as the legacy `/fx-rates` routes they replace.
 */

import { PERMISSIONS } from '@/lib/permissions'

export const CURRENCY_RATE_PERMISSIONS = {
  /** Lists rate history and resolves the rate in force for a date. */
  read: PERMISSIONS.fxRateRead,
  /** Records or corrects a rate (held for review when outside tolerance). */
  manage: PERMISSIONS.fxRateManage,
  /**
   * Requests and executes a retroactive revaluation (F-6.006). The execute
   * route refuses unless two distinct approvers have signed the request.
   */
  revaluationSubmit: 'fx.revaluation.submit',
} as const
